import PropTypes from "prop-types";
import React from "react";
import injectSheet from "react-jss";

const styles = theme => ({
  circle: {
    width: "300px",
    height: "300px",
    borderRadius: "150px",
    display: "inline-block",
    backgroundPosition: "center",
    backgroundRepeat: "no-repeat",
    backgroundSize: "contain",
    fontSize: "1.5rem",
    "@media (max-width: 823px)": {
      width: "150px",
      height: "150px",
      borderRadius: "75px",
      fontSize: "1rem"
    },
    "& p": {
      display: "none"
    },
    "&:hover": {
      backgroundColor: theme.colours.palette.blue,
      color: theme.colours.palette.white,
      "& img": {
        display: "none"
      },
      "& p": {
        display: "block",
        textAlign: "center"
      }
    },
    "&:focus": {
      backgroundColor: theme.colours.palette.blue,
      color: theme.colours.palette.white,
      "& img": {
        display: "none"
      },
      "& p": {
        display: "block",
        textAlign: "center"
      }
    },
    "&:active": {
      backgroundColor: theme.colours.palette.blue,
      color: theme.colours.palette.white,
      "& img": {
        display: "none"
      },
      "& p": {
        display: "block",
        textAlign: "center"
      }
    }
  },
  photo: {
    width: "300px",
    height: "300px",
    borderRadius: "150px",
    display: "inline-block",
    "@media (max-width: 823px)": {
      width: "150px",
      height: "150px",
      borderRadius: "75px"
    }
  },
  topParagraph: {
    marginTop: "7rem",
    marginBottom: 0,
    "@media (max-width: 823px)": {
      marginTop: "2.5rem"
    }
  },
  bottomParagraph: {
    marginTop: 0
  }
});

const FacePhoto = ({ classes, image, employee, position }) => (
  <div className={classes.circle}>
    <p className={classes.topParagraph}>{employee}</p>
    <p className={classes.bottomParagraph}>{position}</p>
    <img src={image} className={classes.photo} />
  </div>
);

FacePhoto.propTypes = {
  classes: PropTypes.object,
  image: PropTypes.string,
  employee: PropTypes.string,
  position: PropTypes.string
};

export default injectSheet(styles)(FacePhoto);



// WEBPACK FOOTER //
// ./src/components/FacePhoto.jsx